/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: Anil
 */

/******** Reducers ********/

const initialState = {
    phoneNumbers: null,
    error: null,
    numbers_list: null,
    porting_phone_number: {
        loading: false,
        data: null,
        error: null
    },
    phone_number_pricing: {
        loading: false,
        data: null,
        error: null
    }
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'CHATBOT_SUCCESS':
            return action.data;

        case "PHONE_NUMBERS_SUCCESS_COUNTRY_LIST":
            return { ...state, phoneNumbers: action.data, error: null };

        case "PHONE_NUMBERS_FAILURE_COUNTRY_LIST":
            return { ...state, error: action.error };

        case "ALL_PHONE_NUMBERS_SUCCESS":
            return { ...state, numbers_list: action.data, error: null };
        case "ALL_PHONE_NUMBERS_FAILED":
            return { ...state, error: action.error };

        // porting phone number api
        case "PORT_PHONE_NUMBER_REQUEST":
            return {
                ...state,
                porting_phone_number: { loading: true, data: null, error: null }
            };
        case "PORT_PHONE_NUMBER_SUCCESS":
            return {
                ...state,
                porting_phone_number: { loading: false, data: action.data, error: null }
            };;
        case "PORT_PHONE_NUMBER_FAILED":
            return {
                ...state,
                porting_phone_number: { loading: false, data: null, error: action.data }
            };;


        // porting phone number api
        case "GetPhoneNumberLocalPriceAPI_pending":
            return {
                ...state,
                phone_number_pricing: { loading: true, data: null, error: null }
            };
        case "GetPhoneNumberLocalPriceAPI_success":
            return {
                ...state,
                phone_number_pricing: { loading: false, data: action.data, error: null }
            };;
        case "GetPhoneNumberLocalPriceAPI_failed":
            return {
                ...state,
                phone_number_pricing: { loading: false, data: null, error: action.data }
            };

        case "reset_TwilioPhonrNumberPriceState":
            return {
                ...state,
                phone_number_pricing: { loading: false, data: null, error: null }
            };

        default:
            return state;
    }
}





export const reset_TwilioPhonrNumberPriceState = () => ({
    type: "reset_TwilioPhonrNumberPriceState",
});
